import "./Share.css";

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useT } from "../../i18n/useT";

// eslint-disable-next-line no-undef
const PUBLIC_URL = process.env.PUBLIC_URL || "";

const Share = ({ path, title, heading }) => {
  const t = useT();
  const [copied, setCopied] = useState(false);

  const url = useMemo(() => {
    if (typeof window === "undefined") return "";
    return `${window.location.origin}${PUBLIC_URL}${path}`;
  }, [path]);

  useEffect(() => {
    if (!copied) return undefined;
    const id = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(id);
  }, [copied]);

  const handleCopy = () => {
    if (!url || !navigator.clipboard) return;
    navigator.clipboard.writeText(url).then(() => setCopied(true));
  };

  return (
    <div className="share">
      {heading && <h4 className="h6 text-muted mb-2">{heading}</h4>}
      <div className="share-row">
        <TelegramShareButton url={url} title={title}>
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        <FacebookShareButton url={url} title={title}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton url={url} title={title}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <LinkedinShareButton url={url} title={title}>
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
        <WhatsappShareButton url={url} title={title}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <RedditShareButton url={url} title={title}>
          <RedditIcon size={32} round />
        </RedditShareButton>
        <button
          type="button"
          onClick={handleCopy}
          className="btn btn-sm btn-outline-secondary share-copy"
          aria-label={t("share.copyLink")}
          title={t("share.copyLink")}
          disabled={!url}
        >
          <i className="fa fa-link" aria-hidden="true"></i>
        </button>
        {copied && (
          <span className="share-feedback" role="status">
            {t("share.linkCopied")}
          </span>
        )}
      </div>
    </div>
  );
};

Share.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string,
  heading: PropTypes.string,
};

export default Share;
